angular.module('tradersyard').directive('userForm', [
    '$parse',
    'graph-like-factory',
    function ($parse, $client) {
        return {
            link: function ($scope, $element, $attr) {},
        };
    },
]);
